/**
 * Generates a unique identifier
 * @returns UID
 */
import uuid from 'react-native-uuid';

export function generateUniqueID() {
    return(uuid.v4());
}


